import React, { useEffect, useState } from "react";
import { FaChevronUp } from "react-icons/fa";

const BackToTop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className="fixed bottom-6 right-6 z-50 bg-yellow-400 hover:bg-yellow-300 text-black rounded-full p-3 shadow-lg transition-all duration-200"
      aria-label="Back to top"
    >
      <FaChevronUp size={16} />
    </button>
  );
};

export default BackToTop;
